<div class="b-feature">
  <div class="container">
    <div class="m-tools d-none d-sm-flex" [hidden]="searchBoxStatus.isShow">
      <button class="btn btn-trans text-gray" (click)="showSearchBox()">
        <svg role="img">
          <use xlink:href="#icon-search"></use>
        </svg>
      </button>
      <button data-view class="btn btn-trans-line text-gray ml-3" (click)="changeSortType()">
        <svg role="img" *ngIf="queryStoriesData.pagination.sort == 'asc'">
          <use xlink:href="#icon-filter-dn"></use>
        </svg>
        <svg role="img" *ngIf="queryStoriesData.pagination.sort == 'desc'">
          <use xlink:href="#icon-filter"></use>
        </svg>
      </button>

      <button data-view class="btn btn-trans-line text-gray ml-3 d-none d-md-block" (click)="changeViewType()">
        <svg role="img" *ngIf="!isViewList">
          <use xlink:href="#icon-list"></use></svg>
          <svg role="img" *ngIf="isViewList">
          <use xlink:href="#icon-grid"></use></svg>
      </button>
    </div>

    <!-- Start Story-->
    <div class="m-story" [ngClass]="{'m-story--list': isViewList}">
      <div class="m-story__content">
        <skeleton-story-list class="row grid" *ngIf="(!stories || stories.length === 0) && loadStoryStatus.isLoading"
          [countItem]="8" [cssClassItem]="'col-12 col-sm-6 col-md-4 col-xl-3 px-2 grid-item'"></skeleton-story-list>

        <div gs-masonry [options]="{itemSelector:'.grid-item'}" [totalItem]="stories.length" [useImagesLoaded]="true"
          class="row grid">
          <co-pb-landing-story-item [enable_labels]="enable_labels" [user_label_text]="user_label_text" [guest_label_text]="guest_label_text" [userLables]="userLables" [GuestLables]="GuestLables" gsMasonryItem class="col-12 col-sm-6 col-md-4 col-xl-3 px-2 grid-item"
            [story]="story" [href]="'/c/' + story.companyIdSlug + '/' + story.slug"
            *ngFor="let story of stories; trackBy: trackByFunc" [stepsData]="stepsData">
          </co-pb-landing-story-item>

        </div>

        <div *ngIf="landingPage?.isInboundStoriesEnabled && (stories.length === 0 && !loadStoryStatus.isLoading)"
          class="row mb-5 text-center text-lg-left">
          <!--<div class="d-none d-lg-block col-12 mb-3 mb-lg-0 offset-lg-1 col-lg-5 pr-lg-7">
            <img src="/assets/front-end-minify/img/catch-a-story.png" />
          </div>-->
          <div class="col-12 col-lg-5">
            <h3 class="mt-lg-6 mb-3">Share your story.</h3>
            <a [routerLink]="['/t/' + landingPage.companySlug + '/testimonial/create']" class="btn btn-pink">Get
              Started</a>
          </div>
        </div>

        <div
          *ngIf="!landingPage?.isInboundStoriesEnabled && (stories.length === 0 && loadStoryStatus.isLoaded && !loadStoryStatus.isLoading)"
          class="row mb-5 text-center text-lg-left">
          <!--<div class="d-none d-lg-block col-12 mb-3 mb-lg-0 offset-lg-1 col-lg-5 pr-lg-7">
            <img src="/assets/front-end-minify/img/catch-a-story.png" />
          </div>-->
          <div class="col-12 col-lg-5">
            <h3 class="mt-lg-6 mb-3">Our heroes are busy catching stories for you to read.</h3>
            <p>Check back soon!</p>
          </div>
        </div>
      </div>
    </div>
    <!-- Close Story-->
  </div>
</div>
<app-infinity-scroll (infinite)="loadMoreStories()" [showIndicator]="showIndicator" [disabled]="disabled">
</app-infinity-scroll>